<template>
  <div>
    <b-card>
      <template #header>
        <b-row class="pt-1">
          <b-col cols="10" class="d-flex">
            <b-link :to="{name: 'AdminUsers'}">
              <h4 class="ms-2">
                {{label.pages.personnels}}
              </h4>
            </b-link>
            /
            <h4 class="me-2">
              {{ $route.meta.label }}
            </h4>
          </b-col>
          <b-col cols="2" class="text-start">
            <a
                @click="$router.go(-1)"
                v-b-tooltip.hover.right
                :title="label.pages.previousPage"
                class="mouse-change pe-3"
            >
              <b-icon
                  icon="arrow-left-square-fill"
                  variant="ps-base"
                  scale="1.2"
                  class="align-middle ms-1"
              />
            </a>
          </b-col>
        </b-row>
      </template>
      <b-card-body>
        <b-card-text>
          <DxDataGrid
              :show-row-lines="true"
              :show-column-lines="true"
              :show-borders="true"
              :row-alternation-enabled="true"
              :rtl-enabled="true"
              :data-source="roles"
              :columns="fields"
              :remote-operations="true"
              :column-auto-width="true"
              :allow-column-reordering="true"
              :allow-column-resizing="true"
              column-resizing-mode="widget"
              :hover-state-enabled="true"
              :noDataText="checkData"
              @toolbar-preparing="onToolbarPreparing($event)"
              key-expr="id"
              class="ps_Table"
              :height="dataGridHeight"
          >
            <DxSearchPanel
                :visible="true"
                :width="240"
                :placeholder="label.pages.search"
            />
            <template #btnRGroup>
              <div></div>
            </template>
            <template #btnGroup>
              <div>
                <b-row class="ms-1">
                  <b-col cols="auto" class="px-1">
                    <b-button
                      variant="ps-success"
                      class="py-1 pb-2"
                      size="sm"
                      v-b-tooltip.hover
                      :title="label.buttons.addNewRole"
                      @click="add"
                    >
                      <b-icon icon="plus" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                  <b-col cols="auto" class="px-0">
                    <b-button
                        variant="ps-secondary"
                        class="py-1 pb-2"
                        size="sm"
                        v-b-tooltip.hover
                        :title="label.buttons.reload"
                        @click="reloadData"
                    >
                      <b-icon icon="arrow-repeat" scale="1.5" color="#fff"></b-icon>
                    </b-button>
                  </b-col>
                </b-row>
              </div>
            </template>
            <template #radif="{data}">
              <div>
                {{ data.rowIndex + 1 }}
              </div>
            </template>
            <template #actions="{data}">
              <b-row class="justify-content-center">
                <b-col cols="auto" class="px-1">
                  <button
                    @click="goPermissions(data)"
                    :id="'rolePermissionsBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="shield-fill-exclamation"
                      scale="1.1"
                      variant="ps-info"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'rolePermissionsBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.rolePermissions }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                      @click="edit(data)"
                      :id="'editBtnTlp-' + data.data.id"
                  >
                    <b-icon icon="dash-square-fill" scale="1.1" variant="ps-edit-icon"></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'editBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.edit }}
                  </b-tooltip>
                </b-col>
                <b-col cols="auto" class="px-1">
                  <button
                    @click="delConfirm(data)"
                    :id="'deleteBtnTlp-' + data.data.id"
                  >
                    <b-icon
                      icon="x-square-fill"
                      scale="1.1"
                      variant="ps-delete-icon"
                    ></b-icon>
                  </button>
                  <b-tooltip
                    boundary="#app"
                    noninteractive
                    triggers="hover"
                    :target="'deleteBtnTlp-' + data.data.id"
                  >
                    {{ label.buttons.delete }}
                  </b-tooltip>
                </b-col>
              </b-row>
            </template>
            <DxLoadPanel :enabled="true"/>
            <DxScrolling mode="virtual"/>
          </DxDataGrid>
        </b-card-text>
      </b-card-body>
    </b-card>

      <!--  Add Modal -->
      <b-modal
      :dir="label.direction"
      v-model="addModal"
      header-bg-variant="ps-success"
      centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{ label.pages.newRole }}
        </h4>
        <button class="ps-closeModalBtn" @click="close" id="closeAddModalTlp">
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeAddModalTlp"
        >
          {{ label.buttons.closeModal }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="mt-1">
          <b-col sm="3">
            <label for="title" class="ps_label"
              >{{ label.form.title }}
              <span class="ps_label_star">*</span></label
            >
          </b-col>
          <b-col sm="9">
            <b-form-input
              id="title"
              size="sm"
              v-model="form.title"
              autofocus
              class="text-center"
              @keyup.enter="addItem"
            />
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col sm="3">
            <label for="desc" class="ps_label"
              >{{ label.form.description }}
              <span class="ps_label_star">*</span></label
            >
          </b-col>
          <b-col sm="9">
            <b-form-textarea id="desc" size="sm" v-model="form.description" />
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="close"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-success"
              size="sm"
              class="mx-1"
              @click="addItem"
            >
              {{ label.buttons.submit }}
            </b-button>
            <b-button
              v-else
              variant="ps-success"
              size="sm"
              class="mx-1"
              disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- edit Modal -->
    <b-modal
        dir="rtl"
        v-model="editModal"
        header-bg-variant="ps-warning"
        centered
    >
      <template #modal-header>
        <h4 class="text-white fw1">
          {{label.captions.editRole}}
        </h4>
        <button
            class="ps-closeModalBtn"
            @click="editModal=false"
            id="closeEditModalTlp"
        >
          <b-icon icon="x-square"></b-icon>
        </button>
        <b-tooltip
          boundary="#app"
          noninteractive
          triggers="hover"
          target="closeEditModalTlp"
        >
          {{ label.pages.closeTab }}
        </b-tooltip>
      </template>
      <b-container fluid>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="title" class="ps_label">{{label.form.title}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-input
              id="title"
              size="sm"
              v-model="form.title"
              disabled
              class="text-center"
            />
          </b-col>
        </b-row>
        <b-row class="my-3">
          <b-col sm="3">
            <label for="desc" class="ps_label">{{label.form.description}}</label>
          </b-col>
          <b-col sm="9">
            <b-form-textarea id="desc" size="sm" v-model="form.description"/>
          </b-col>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
                variant="ps-secondary"
                size="sm"
                class="mx-1"
                @click="editModal=false"
            >
            {{label.buttons.cancel}}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
                v-if="!loadingBtn"
                variant="ps-warning"
                size="sm"
                class="mx-1"
                @click="editItem"
            >
            {{label.buttons.saveChanges}}
            </b-button>
            <b-button
                v-else
                variant="ps-warning"
                size="sm"
                class="mx-1"
                disabled
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

     <!-- Delete Confirm Modal -->
     <b-modal :dir="label.direction" v-model="delModal" hide-header centered>
      <b-container fluid>
        <b-row class="mt-2">
          <p class="fs10 text-center lh1 mb-0">
            {{ label.captions.deleteConfirm }}
            <br />
          </p>
        </b-row>
      </b-container>
      <template #modal-footer>
        <b-row class="w-100 justify-content-end">
          <b-col cols="auto" class="px-0">
            <b-button
              variant="ps-secondary"
              size="sm"
              class="mx-1"
              @click="close"
            >
              {{ label.buttons.cancel }}
            </b-button>
          </b-col>
          <b-col cols="auto" class="px-0">
            <b-button
              v-if="!loadingBtn"
              variant="ps-danger"
              size="sm"
              class="mx-1"
              @click="deleteItem"
            >
              {{ label.buttons.deleteConfirm }}
            </b-button>
            <b-button
              v-else
              disabled
              variant="ps-danger"
              size="sm"
              class="mx-1"
            >
              <b-spinner small></b-spinner>
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {dataGridMixin} from '@/components/dataGrid/dataGridMixin'
import label from "@/plugins/StaticLabels.js";
import alert from "@/plugins/AlertMessages.js";

export default {
  name: 'AdminUserRoles',
  mixins: [dataGridMixin],
  data() {
    return {
      label,
      fields: [
        {
          cellTemplate: 'radif',
          caption: 'ردیف',
          allowSorting: false,
          allowFiltering: false,
          width: '110',
          cssClass: 'text-center align-middle fs10'
        },
        {
          cellTemplate: 'actions',
          caption: 'عملیات',
          allowSorting: false,
          allowFiltering: false,
          width: '120',
          cssClass: 'text-center align-middle'
        },
        {
          dataField: 'title',
          caption: 'عنوان نقش',
          dataType: 'string',
          cssClass: 'text-center align-middle fw2'
        },
        {
          dataField: 'description',
          caption: 'توضیحات',
          allowSorting: false,
          allowFiltering: false,
          cssClass: 'text-center align-middle'
        },
      ],
      addModal: false,
      editModal: false,
      delModal: false,
      itemId: null,
      form: {
          title: null,
          description: '',
      },
    }
  },
  computed: {
    ...mapGetters({
      postCheck: 'postCheck',
      roles: 'baseX/roles',
      loadingBtn: 'loadingBtn',
    }),
  },
  watch: {
    postCheck() {
      if (this.postCheck) {
        this.close();
        this.reloadData();
        this.reloadFields();
      }
    },
  },
  methods: {
    goPermissions(item) {
      this.$router.push({
        name: "RolePermissions",
        params: { id: item.data.id },
      });
    },
    add() {
      this.$store.dispatch("baseX/test");
      this.reloadFields();
      this.addModal = true;
    },
    addItem() {
      if (this.form.title && this.form.description) {
        this.$store.dispatch("baseX/addRole", this.form);
      } else {
        this.$store.commit("setError", alert.error.empty);
      }
    },
    edit(item) {
      this.itemId = item.data.id;
      this.form = {
        title: item.data.title,
        description: item.data.description,
      };
      this.editModal = true;
    },
    editItem() {
      if(this.form.title && this.form.title != ''){
        const payload = {
          id: this.itemId,
          value: this.form
        };
        this.$store.dispatch('baseX/editRole', payload);
      }
    },
    delConfirm(item) {
      this.itemId = item.data.id;
      this.delModal = true;
    },
    deleteItem() {
      this.$store.dispatch("baseX/deleteRole", this.itemId);
      this.close();
    },
    close() {
      this.addModal = false;
      this.delModal = false;
      this.editModal = false;
    },
    reloadFields() {
      this.form = {
        title: null,
        description: '',
      };
    },
    reloadData() {
      this.$store.dispatch('baseX/getRoles');
    },
  },
  mounted() {
    this.reloadData();
  },
}
</script>
